import React, { useEffect, useRef, useState } from 'react';
import './GroupForm.css';
import { useNavigate } from 'react-router-dom';
import GetAccessToken from "./Tokens";
import { useConfig } from './ConfigContext';

const GroupForm = ({
                       initialData = {},
                       isEdit = false,
                       onClose,
                       onGroupSaved
                   }) => {
    const [groupName, setGroupName] = useState(initialData['group_name'] || '');
    const [groupDescription, setGroupDescription] = useState(initialData['description'] || '');
    const [groupImage, setGroupImage] = useState(null);
    const [errorMessage, setErrorMessage] = useState('');
    const navigate = useNavigate();
    const ref = useRef(null);
    const [groupServiceUrl, setGroupServiceUrl] = useState(null);
    const config = useConfig();

    useEffect(() => {
        if (config) {
            setGroupServiceUrl(config["group_service_url"]);
        }
    }, [config]);

    const handleImageUpload = (e) => {
        setGroupImage(e.target.files[0]);
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (ref.current && !ref.current.contains(event.target)) {
                onClose();
            }
        };

        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [onClose]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setErrorMessage('');
        let access_token = await GetAccessToken(config["user_service_url"]);
        if (access_token === null) {
            navigate('/login');
            return;
        }

        const formData = new FormData();
        if (isEdit) {
            formData.append('group_id', initialData['group_id']);
            if (groupName !== initialData['group_name']) {
                formData.append('new_name', groupName);
            }
            if (groupDescription !== initialData['description']) {
                formData.append('new_description', groupDescription);
            }
            if (groupImage) {
                formData.append('new_image', groupImage);
            }
        } else {
            formData.append('group_name', groupName);
            formData.append('group_description', groupDescription);
            if (groupImage) {
                formData.append('group_image', groupImage);
            }
        }


        try {
            const xhr = new XMLHttpRequest();
            const endpoint = isEdit
                ? `${groupServiceUrl}/private/group`
                : `${groupServiceUrl}/private/group`;
            const method = isEdit ? 'PATCH' : 'POST';

            xhr.open(method, endpoint, true);
            xhr.setRequestHeader('Authorization', `Bearer ${access_token}`);

            xhr.onload = async () => {
                if (xhr.status === 200 || xhr.status === 201) {
                    const result = JSON.parse(xhr.responseText);
                    const savedGroup = {
                        "group_name": groupName,
                        "description": groupDescription,
                        "group_id": result.group_id || initialData['group_id']}
                    onGroupSaved(savedGroup);
                    onClose();
                } else if (xhr.status === 401) {
                    sessionStorage.removeItem('access_token');
                    console.error('Unauthorized:', xhr.statusText);
                    await handleSubmit();
                } else {
                    const errorBody = JSON.parse(xhr.responseText);
                    setErrorMessage(`Error: ${errorBody.message || 'Something went wrong'}`);
                }
            };

            xhr.onerror = () => {
                setErrorMessage(`Failed to ${isEdit ? 'edit' : 'create'} group. Please try again.`);
            };

            xhr.send(formData);
        } catch (error) {
            setErrorMessage('An unexpected error occurred. Please try again later.');
        }
    };

    return (
        <div ref={ref} className="group-form-container">
            <h2>{isEdit ? 'Edit Group' : 'Create Group'}</h2>
            <form onSubmit={handleSubmit}>
                <div className="form-group">
                    <label htmlFor="groupName">Group Name:</label>
                    <input
                        type="text"
                        id="groupName"
                        value={groupName}
                        onChange={(e) => setGroupName(e.target.value)}
                        required
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="groupDescription">Description:</label>
                    <textarea
                        id="groupDescription"
                        value={groupDescription}
                        onChange={(e) => setGroupDescription(e.target.value)}
                        required
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="groupImage">Group Image:</label>
                    <input
                        type="file"
                        id="groupImage"
                        accept="image/*"
                        onChange={handleImageUpload}
                    />
                </div>
                {errorMessage && <div className="error-message">{errorMessage}</div>}
                <button type="submit">{isEdit ? 'Save Changes' : 'Create Group'}</button>
            </form>
        </div>
    );
};

export default GroupForm;
